import React from "react";
import PropTypes from "prop-types";
import { Button, Dropdown, Loader } from "semantic-ui-react";
import { CancelPublishButton } from "./CancelPublishButton";
import { usePostRequestAction } from "../../hooks";

export const PublishRequestButtonMenu = ({ request }) => {
  const cancelPublishUrl = request?.links.actions?.cancel || null;
  const publishRequestUrl = request.links.self_html;
  const { mutate: cancelPublish, isLoading: isCanceling } =
    usePostRequestAction(cancelPublishUrl);

  const cancelPublishAction = async () => {
    await cancelPublish(cancelPublishUrl, {
      onSuccess: () => {
        location.reload();
      },
    });
  };

  return isCanceling ? (
    <Loader></Loader>
  ) : (
    <Dropdown
      text={"Publish request actions"}
      icon="angle down"
      fluid
      labeled
      button
      className="icon"
    >
      <Dropdown.Menu>
        <Dropdown.Item>
          <Button
            as="a"
            animated="vertical"
            secondary
            size="small"
            href={publishRequestUrl}
            onClick={(e) => e.stopPropagation()}
            fluid
          >
            Publish Request Page
          </Button>
        </Dropdown.Item>
        <Dropdown.Item>
          <CancelPublishButton
            cancelPublishAction={cancelPublishAction}
            isLoading={isCanceling}
          />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

PublishRequestButtonMenu.propTypes = {
  request: PropTypes.object.isRequired,
};
